import { createFileRoute } from '@tanstack/react-router';
import { ConnectedCompanies } from '@/pages/auth/connected-companies/ConnectedCompanies';

export const Route = createFileRoute('/_authenticated/connected-companies')({
	component: ConnectedCompanies,
});
